/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actionTypes';

const initialstate = {
  // active_tab: 'one',
  err_msg: [],
  fld_err: {},
  default_audit: false,
  save_disable: true,
  override_data: {
    useDefSystemInd: 0,
    invoiceMailThreshold: null,
    autoUnderThresholdInd: 0,
    reimbUnderThresholdMult: null,
    sendAllRetainedQtr: null,
    showDisputeOnInvInd: 0,
    forgiveReqCommentInd: null,
    unitConvChangesDataInd: 0,
    nonZeroBilledUnitsInd: null,
    defEarliestQtrForDrugDtls: null,
    defDetailLevelOnInvoiceCd: null,
    progDefDispSpecialist: null,
    defLetterSenderUserId: null,
  },
  deleted_int_calc: [],
  deleted_int_fed: [],
  deleted_int_fed_fmly: [],
  deleted_ura_src: [],
  deleted_ura_calc: [],
  deleted_ura_pay: [],
  deleted_cms_rpt: [],
  deleted_cms_util: [],
  deleted_enroll: [],
};

const reducer = (state = initialstate, action) => {
  switch (action.type) {
    case actiontypes.VIEW_TAB:
      return { ...state, active_tab: action.payload };
    case actiontypes.VIEW_ERROR_MSG:
      return { ...state, err_msg: action.payload };
    case actiontypes.VIEW_FIELD_ERR:
      return { ...state, fld_err: action.payload };
    case actiontypes.MAINTAINRBT_REDUX_CLEAR:
      return initialstate;
    case actiontypes.REBATE_PGM_DETAIL:
      const updatedPayload = { ...action.payload };
      if (updatedPayload.rptBalanceDueThreshold === null) {
        updatedPayload.rptBalanceDueThreshold = 0;
      }
      if (updatedPayload.dbalModThreshold === null) {
        updatedPayload.dbalModThreshold = 0;
      }
      return { ...state, pgm_detail: updatedPayload };
    case actiontypes.DEFAULT_AUDIT:
      return { ...state, default_audit: action.payload };
    case actiontypes.ENABLE_SAVE:
      return { ...state, save_disable: action.payload };
    case actiontypes.COMMENTS_FLAG:
      return { ...state, comment_flag: action.payload };
    case actiontypes.COPY_DATA:
      return { ...state, copy_data: action.payload };
    case actiontypes.URA_GRID_DATA:
      return { ...state, ura_grid_data: action.payload };
    case actiontypes.COPY_URA_GRID_DATA:
      return { ...state, copy_ura_data: action.payload };
    case actiontypes.LAST_FROZEN_QTR:
      return { ...state, last_frozen_qtr: action.payload };
    case actiontypes.LAST_URA_SRC_CALC_QTR:
      return { ...state, last_ura_src_calc_qtr: action.payload };
    case actiontypes.INT_GRID_DATA:
      return { ...state, int_grid_data: action.payload };
    case actiontypes.COPY_INT_GRID_DATA:
      return { ...state, copy_int_data: action.payload };
    case actiontypes.AUDIT_GRID_DATA:
      return { ...state, audit_grid_data: action.payload };
    case actiontypes.COPY_AUDIT_GRID_DATA:
      return { ...state, copy_audit_data: action.payload };
    case actiontypes.CONS_AUDIT_DATA:
      return { ...state, audit_data: action.payload };
    case actiontypes.OVERRIDR_DATA:
      return { ...state, override_data: action.payload };
    case actiontypes.DEFAULT_OVERRIDE_DATA:
      return { ...state, def_override: action.payload };
    case actiontypes.SYSTEM_OVERRIDE_DATA:
      return { ...state, sys_override: action.payload };
    case actiontypes.UNIT_TYPE_AUDIT_GRID_DATA:
      return { ...state, unit_type_data: action.payload };
    case actiontypes.COPY_UNIT_TYPE_DATA:
      return { ...state, copy_unit_type_data: action.payload };
    case actiontypes.GROUP_GRID_DATA:
      return { ...state, group_data: action.payload };
    case actiontypes.COPY_GROUP_GRID_DATA:
      return { ...state, copy_group_data: action.payload };
    case actiontypes.ENROLL_GRID_DATA:
      return { ...state, enroll_data: action.payload };
    case actiontypes.COPY_ENROLL_GRID_DATA:
      return { ...state, copy_enroll_data: action.payload };
    case actiontypes.DELETED_INT_CALC:
      return { ...state, deleted_int_calc: action.payload };
    case actiontypes.DELETED_INT_FED:
      return { ...state, deleted_int_fed: action.payload };
    case actiontypes.DELETED_INT_FED_FMLY:
      return { ...state, deleted_int_fed_fmly: action.payload };
    case actiontypes.DELETED_URA_SOURCE:
      return { ...state, deleted_ura_src: action.payload };
    case actiontypes.DELETED_URA_CALC:
      return { ...state, deleted_ura_calc: action.payload };
    case actiontypes.DELETED_URA_PAY:
      return { ...state, deleted_ura_pay: action.payload };
    case actiontypes.DELETED_CMS_RPT:
      return { ...state, deleted_cms_rpt: action.payload };
    case actiontypes.DELETED_CMS_UTIL:
      return { ...state, deleted_cms_util: action.payload };
    case actiontypes.DELETED_ENROLL:
      return { ...state, deleted_enroll: action.payload };
    case actiontypes.CMS_FREEZE_QTR:
      return { ...state, cms_freeze_qtr: action.payload };
    case actiontypes.MAX_ENROLL_QTR:
      return { ...state, max_enroll_qtr: action.payload };
    case actiontypes.USE_DEF_AUDIT:
      return { ...state, use_def_audit: action.payload };
    case actiontypes.CUSTOM_RESET:
      return { ...state, ...initialstate };
    case actiontypes.SAVE_INFO:
      return { ...state, save_info: action.payload };
    case actiontypes.RESET_STORE:
      return initialstate;
    default:
      return state;
  }
};

export default reducer;
